module.exports = __webpack_public_path__ + "img/partners.1d5da8cd.svg";